@if (!elType()) {
  <span [ngClass]="classes">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </span>
}
@if (elType() === 'header') {
  <h1 [ngClass]="classes">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </h1>
}
@if (elType() === 'text') {
  <p [ngClass]="classes">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </p>
}
@if (elType() === 'label') {
  <label [ngClass]="classes">
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </label>
}

<ng-template #text>
  <ng-content></ng-content>
</ng-template>
